"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledIcon = exports.StyledLink = exports.classes = void 0;
const Link_1 = __importDefault(require("@mui/material/Link"));
const styles_1 = require("@mui/material/styles");
const Icon_1 = __importDefault(require("../icon/Icon"));
const PREFIX = "AnchorLink";
exports.classes = {
    disabled: `${PREFIX}-disabled`,
    white: `${PREFIX}-white`,
    black: `${PREFIX}-black`,
    icon: `${PREFIX}-icon`
};
exports.StyledLink = (0, styles_1.styled)(Link_1.default)(({ theme }) => ({
    color: theme.colours.inter,
    textDecoration: "underline",
    textDecorationColor: "currentColor",
    fontSize: "inherit",
    display: "inline-flex",
    alignItems: "center",
    position: "relative",
    cursor: "pointer",
    "&::before": {
        content: '""',
        position: "absolute",
        height: "42px",
        top: "50%",
        marginTop: "-21px",
        left: 0,
        right: 0
    },
    "&:hover": {
        color: theme.colours.focus,
        transition: `currentColor 250ms ease-out, color 250ms ease-out`
    },
    [`&.${exports.classes.disabled}`]: {
        opacity: 0.3,
        pointerEvents: "none"
    },
    [`&.${exports.classes.white}`]: {
        color: (0, styles_1.alpha)(theme.colours.white, 0.8),
        "&:hover": {
            color: theme.colours.white
        }
    },
    [`&.${exports.classes.black}`]: {
        color: (0, styles_1.alpha)(theme.colours.black, 0.8),
        "&:hover": {
            color: theme.colours.black
        }
    }
}));
exports.StyledIcon = (0, styles_1.styled)(Icon_1.default)({
    width: "16px",
    height: "16px",
    fill: "currentColor",
    "&:first-of-type": {
        marginRight: "12px"
    },
    "&:last-of-type": {
        marginLeft: "12px"
    }
});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3R5bGVzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2FuY2hvci1saW5rL3N0eWxlcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7QUFBQSw4REFBc0M7QUFDdEMsaURBQXFEO0FBQ3JELHdEQUFnQztBQUVoQyxNQUFNLE1BQU0sR0FBRyxZQUFZLENBQUM7QUFFZixRQUFBLE9BQU8sR0FBRztJQUNyQixRQUFRLEVBQUUsR0FBRyxNQUFNLFdBQVc7SUFDOUIsS0FBSyxFQUFFLEdBQUcsTUFBTSxRQUFRO0lBQ3hCLEtBQUssRUFBRSxHQUFHLE1BQU0sUUFBUTtJQUN4QixJQUFJLEVBQUUsR0FBRyxNQUFNLE9BQU87Q0FDdkIsQ0FBQztBQUVXLFFBQUEsVUFBVSxHQUFHLElBQUEsZUFBTSxFQUFDLGNBQUksQ0FBQyxDQUNwQyxDQUFDLEVBQUUsS0FBSyxFQUFFLEVBQUUsRUFBRSxDQUFDLENBQUM7SUFDZCxLQUFLLEVBQUUsS0FBSyxDQUFDLE9BQU8sQ0FBQyxLQUFLO0lBQzFCLGNBQWMsRUFBRSxXQUFXO0lBQzNCLG1CQUFtQixFQUFFLGNBQWM7SUFDbkMsUUFBUSxFQUFFLFNBQVM7SUFDbkIsT0FBTyxFQUFFLGFBQWE7SUFDdEIsVUFBVSxFQUFFLFFBQVE7SUFDcEIsUUFBUSxFQUFFLFVBQVU7SUFDcEIsTUFBTSxFQUFFLFNBQVM7SUFDakIsV0FBVyxFQUFFO1FBQ1gsT0FBTyxFQUFFLElBQUk7UUFDYixRQUFRLEVBQUUsVUFBVTtRQUNwQixNQUFNLEVBQUUsTUFBTTtRQUNkLEdBQUcsRUFBRSxLQUFLO1FBQ1YsU0FBUyxFQUFFLE9BQU87UUFDbEIsSUFBSSxFQUFFLENBQUM7UUFDUCxLQUFLLEVBQUUsQ0FBQztLQUNUO0lBQ0QsU0FBUyxFQUFFO1FBQ1QsS0FBSyxFQUFFLEtBQUssQ0FBQyxPQUFPLENBQUMsS0FBSztRQUMxQixVQUFVLEVBQUUsbURBQW1EO0tBQ2hFO0lBQ0QsQ0FBQyxLQUFLLGVBQU8sQ0FBQyxRQUFRLEVBQUUsQ0FBQyxFQUFFO1FBQ3pCLE9BQU8sRUFBRSxHQUFHO1FBQ1osYUFBYSxFQUFFLE1BQU07S0FDdEI7SUFDRCxDQUFDLEtBQUssZUFBTyxDQUFDLEtBQUssRUFBRSxDQUFDLEVBQUU7UUFDdEIsS0FBSyxFQUFFLElBQUEsY0FBSyxFQUFDLEtBQUssQ0FBQyxPQUFPLENBQUMsS0FBSyxFQUFFLEdBQUcsQ0FBQztRQUN0QyxTQUFTLEVBQUU7WUFDVCxLQUFLLEVBQUUsS0FBSyxDQUFDLE9BQU8sQ0FBQyxLQUFLO1NBQzNCO0tBQ0Y7SUFDRCxDQUFDLEtBQUssZUFBTyxDQUFDLEtBQUssRUFBRSxDQUFDLEVBQUU7UUFDdEIsS0FBSyxFQUFFLElBQUEsY0FBSyxFQUFDLEtBQUssQ0FBQyxPQUFPLENBQUMsS0FBSyxFQUFFLEdBQUcsQ0FBQztRQUN0QyxTQUFTLEVBQUU7WUFDVCxLQUFLLEVBQUUsS0FBSyxDQUFDLE9BQU8sQ0FBQyxLQUFLO1NBQzNCO0tBQ0Y7Q0FDRixDQUFDLENBQ0gsQ0FBQztBQUVXLFFBQUEsVUFBVSxHQUFHLElBQUEsZUFBTSxFQUFDLGNBQUksQ0FBQyxDQUFDO0lBQ3JDLEtBQUssRUFBRSxNQUFNO0lBQ2IsTUFBTSxFQUFFLE1BQU07SUFDZCxJQUFJLEVBQUUsY0FBYztJQUNwQixpQkFBaUIsRUFBRTtRQUNqQixXQUFXLEVBQUUsTUFBTTtLQUNwQjtJQUNELGdCQUFnQixFQUFFO1FBQ2hCLFVBQVUsRUFBRSxNQUFNO0tBQ25CO0NBQ0YsQ0FBQyxDQUFDIn0=